import { useTranslation } from "react-i18next";
import DigitalServicesHero from "../digitalServicesHero";
import SolutionsView from "../solutionsView";
import TechStackList from "../techStackList";
import projectsData from '../../../assets/data/projects.json';
import { Stack } from "@mui/material";
import ButtonComponent from "../../../components/form/buttonComponent";
import {  useEffect, useCallback, useState } from "react";
import ProjectDetails from "../projectDetails";
import GetQuote from "../../contactUs/getQuote";
import companyData from '../../../assets/data/company.json';

const key = "services.digital.mobile";

const techStackList = [
    { src: "/images/tech-stack/AndroidStudio.png", alt: "Android Studio" },
    { src: "/images/tech-stack/Swift.png", alt: "Swift" },
    { src: "/images/tech-stack/Objective-C.png", alt: "Objective-C" },
    { src: "/images/tech-stack/Kotlin.png", alt: "Kotlin" },
    { src: "/images/tech-stack/Xcode.png", alt: "Xcode" },
    { src: "/images/tech-stack/Java.png", alt: "Java" },
    { src: "/images/tech-stack/Flutter.png", alt: "Flutter" },
    { src: "/images/tech-stack/ReactNative.png", alt: "ReactNative" },
    { src: "/images/tech-stack/Xamarin.png", alt: "Xamarin" },
    { src: "/images/tech-stack/Ionic.png", alt: "Ionic" },
    { src: "/images/tech-stack/Firebase.png", alt: "Firebase" },
    { src: "/images/tech-stack/GraphQL.png", alt: "GraphQL" },
    { src: "/images/tech-stack/RESTAPIs.png", alt: "REST APIs" },
    { src: "/images/tech-stack/SQLite.png", alt: "SQLite" },
    { src: "/images/tech-stack/Jenkins.png", alt: "Jenkins" },
    { src: "/images/tech-stack/Selenium.png", alt: "Selenium" },
    { src: "/images/tech-stack/AppleAppStore.png", alt: "Apple App Store" },
    { src: "/images/tech-stack/GooglePlayStore.png", alt: "Google Play Store" },
    { src: "/images/tech-stack/HuaweiAppGallery.png", alt: "Huawei AppGallery" },
    { src: "/images/tech-stack/OneSignal.png", alt: "OneSignal" },
    { src: "/images/tech-stack/GoogleAdMob.png", alt: "Google AdMob" },
    { src: "/images/tech-stack/Git.png", alt: "Git" }
];

const MobileSolutionsLayout = () => {
    const {t} = useTranslation();

    const solutionsList = [
        {title: t(`${key}.categories.1.label`), description: t(`${key}.categories.1.description`), icon: '/images/icons/pwa.svg'},
        {title: t(`${key}.categories.2.label`), description: t(`${key}.categories.2.description`), icon: '/images/icons/cross-platform.svg'},
        {title: t(`${key}.categories.3.label`), description: t(`${key}.categories.3.description`), icon: '/images/icons/mobile.svg'},
        {title: t(`${key}.categories.4.label`), description: t(`${key}.categories.4.description`), icon: '/images/icons/setting.svg'}
    ];

    const [getQuote, setGetQuote] = useState(false);

    const getAQuote = useCallback(() => {
        // setGetQuote(true);

        window.open(companyData.contact.formLinks.quotation, "_blank");
    }, []);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <DigitalServicesHero 
                banner="/images/services/digital/mobile/mobileBanner.png"
                title={t(`${key}.label`)}
                description={t(`${key}.description`)}
                imageLgSize="60%"
            />

            <SolutionsView list={solutionsList}/>

            <TechStackList list={techStackList}/>

            <ProjectDetails 
                list={projectsData.mobile}
                px="7.5%"
            />

            <Stack
                direction='row'
                justifyContent='center'
                alignItems='center'
                width='100%'
                pb={{xs: 2, md: 0}}
            >
                <ButtonComponent 
                    label={t('services.interested')}
                    onClick={getAQuote}
                    sx={{
                        animation: 'bounceButton 1s infinite'
                    }}
                />
            </Stack>

            <GetQuote open={getQuote} setOpen={setGetQuote}/>
        </>
    );
}

export default MobileSolutionsLayout;